import React, { useEffect, useState } from "react";
import { renderRoutes, RouteConfig } from "react-router-config";
import { 
  // useHistory,
  useLocation } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import packageJson from "../package.json";
import "./App.css";
import { SiteDataProvider } from "./SiteDataProvider";
import { Wrapper } from "./styles";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'; // Import QueryClient
import { fetchRoutes } from "./routes";
import { HelmetProvider } from "react-helmet-async";

const eshopComponentLibPackage = packageJson.dependencies["one-ui-library"];

// Create the QueryClient instance outside the component
const queryClient = new QueryClient();

const App: React.FC = () => {
  const location = useLocation();
  const helmetContext = {};
  // const history = useHistory();

  // const searchParams = new URLSearchParams(decodeURIComponent(location.search));
  // console.log('location=========>', location)
  // console.log('history=========>', history)
  // console.log('searchParams=========>', searchParams);
  // console.log('New env varuale #############', process.env.APPLICATON_ID)

  const [routes, setRoutes] = useState<RouteConfig[]>([]);

  useEffect(() => {
    // Fetch dynamic routes and set them in state
    const loadRoutes = async () => {
      const fetchedRoutes = await fetchRoutes();
      setRoutes(fetchedRoutes);
    };

    loadRoutes();
  }, []);
  
  return (
    <>
    <HelmetProvider context={helmetContext}>
      <QueryClientProvider client={queryClient}> {/* Wrap with QueryClientProvider */}
        <SiteDataProvider slug={location.pathname === '/' ? "home" : location.pathname}>
          <Wrapper
            data-component-library-package={eshopComponentLibPackage}
            className={true ? "styledWrapper sidebarOpen" : "styledWrapper"}
          >
            {renderRoutes(routes)}
          </Wrapper>
        </SiteDataProvider>
      </QueryClientProvider> {/* Close QueryClientProvider */}
    </HelmetProvider>
    </>
  );
};

export default App;
